"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverNavigationItemElement = exports.PopoverNavigationItem = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../TypeListItem/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var _excluded = ["as"];
var PopoverNavigationItemElement = exports.PopoverNavigationItemElement = (0, _styledComponents["default"])(_index.TypeListItem).attrs({
  variant: 'bodySmall',
  condensed: true,
  listStyleReset: true
}).withConfig({
  displayName: "PopoverNavigationItem__PopoverNavigationItemElement",
  componentId: "sc-1w8ibku-0"
})([""]);

/**
 * A list item that renders links or other content in the PopoverNavigationItem.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-popovernavigation-popovernavigationitem--docs) |
 * [Encore site](https://encore.spotify.net/web/components/popover#navigation-popover) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/PopoverNavigationItem) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-12481&t=p9BSbkCzNpWDGLQr-1)
 */
var PopoverNavigationItem = exports.PopoverNavigationItem = /*#__PURE__*/_react["default"].forwardRef(function PopoverNavigationItem(_ref, ref) {
  var as = _ref.as,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(PopoverNavigationItemElement, Object.assign({}, props, {
    ref: ref,
    forwardedAs: as,
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.PopoverNavigationItem
  }));
});